import { useState, useRef, useEffect } from 'react';
import startcase from 'lodash.startcase';
import classNames from 'classnames';
import { compose } from '../../utils/compose';
import { withStrictMode } from '../../utils/with-strict-mode';
import useIsMounted from '../../custom-hooks/useIsMounted';
import InsightCardWrapperStyled, {
  InsightCardImageStyled
} from '../styled-components/InsightCardWrapperStyled';

const AnimatedContent = (props) => {
  const { publishDate } = props.item;
  const date = new Date(publishDate);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  const monthName = months[month];
  const day = date.getUTCDate();
  const localDate = `${monthName} ${day}, ${year}`;

  const showDate = publishDate && publishDate !== '0001-01-01T00:00:00';
  return (
    <div
      className={classNames('animated-content', { hide: props.hidden })}
      aria-hidden={props.isHidden}
    >
      {props.item.primaryCategory && (
        <span className={`tag`}>{startcase(props.item.primaryCategory)}</span>
      )}
      <h3>{props.item.pageTitle}</h3>
      {showDate && (
        <span suppressHydrationWarning className="publish-date">
          {localDate}
        </span>
      )}
      {!props.hidden && <p className="description">{props.item.description}</p>}
    </div>
  );
};

const InsightCard = (props) => {
  const { cardProps, item, isSearchResultCard } = props;
  const [hoverState, setHoverState] = useState(null);
  const featuredCardRef = useRef(null);
  const isMounted = useIsMounted();

  useEffect(() => {
    setHoverState(null);
  }, []);

  const [thumbnail, setThumbnail] = useState('');

  useEffect(() => {
    setThumbnail(item.thumbnail1);
  }, [item.thumbnail1]);

  useEffect(() => {
    document.querySelectorAll('a').forEach((element) => {
      if (element.href === window.location.href) {
        element.removeAttribute('href');
        element.classList.add('inactive-link');
      }
    });
  }, []);

  return (
    <InsightCardWrapperStyled className="insight-card-wrapper" ref={featuredCardRef}>
      <a
        href={item.externalUrl ? item.externalUrl : item.url}
        target={item.isExternal ? '_blank' : '_self'}
        aria-label={`Read more about ${item.pageTitle}`}
        className={`no-underline-link`}
      >
        <div
          className={`insight-card insight-card-${cardProps.layout} insight-card-media-${cardProps.mediaSide}`}
          onMouseEnter={() => setHoverState('hover-in')}
          onMouseLeave={() => setHoverState('hover-out')}
        >
          {item.isFeatured && cardProps.layout === 'standard' && (
            <div className="featured-tag">{cardProps.featuredTagText}</div>
          )}
          <InsightCardImageStyled className="featured-card-image" thumbnail={thumbnail}>
            {(item.primaryCategory?.toLowerCase() === 'podcast' ||
              item.primaryCategory?.toLowerCase() === 'video') && (
              <span className="card-icon-wrapper">
                <span className="material-icons">
                  {item.primaryCategory?.toLowerCase() === 'podcast' ? 'mic_none' : 'play_arrow'}
                </span>
              </span>
            )}
          </InsightCardImageStyled>
          <div className="featured-card-content">
            <div className={classNames('animation-wrapper', hoverState, { mounted: isMounted })}>
              <div className="content-wrapper">
                {cardProps.layout === 'standard' && (
                  <AnimatedContent isSearchResultCard={isSearchResultCard} item={item} hidden />
                )}
                <AnimatedContent isSearchResultCard={isSearchResultCard} item={item} />
              </div>
              <div className="overflow-wrapper">
                {item.readMoreText && (
                  <>
                    <div className="cta-wrapper">
                      <p>
                        <span>{item.readMoreText}</span>
                        <span
                          className={
                            item.isExternal
                              ? 'material-icons-round external-insight-icon'
                              : 'material-icons-round'
                          }
                          aria-hidden="true"
                        >
                          {item.isExternal ? 'open_in_new' : 'chevron_right'}
                        </span>
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </a>
    </InsightCardWrapperStyled>
  );
};

InsightCard.defaultProps = {
  urlTarget: '_self',
  isSearchResultCard: false
};

export default compose(withStrictMode)(InsightCard);
